"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowContactInMobile = exports.ShowContactInMobileWrapper = exports.ProfileSectionWrapper = exports.ReviewsSummaryWrapper = exports.ProviderBadgesWrapper = exports.MobileAvailabilityContainer = exports.ProfileCenterTopContainer = exports.ProfileCenterMeta = exports.ProfileNavigationContainer = exports.Content = exports.ProfileContainer = exports.BookingPanelStickyBox = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("./lib/constants");
const card_container_styles_1 = require("./components/CardContainer/card-container.styles");
// TODO: bring back in react-sticky-box once PMC webpack is upgraded
// https://kyruus.jira.com/browse/KENG-33796
exports.BookingPanelStickyBox = (0, styled_1.default)('div') `
  // desktop only sticky box
  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    ${(props) => {
    var _a, _b;
    if ((_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.third_party) === null || _b === void 0 ? void 0 : _b.cerner_healthelife) {
        return `
          height: 100%;
          position: static;
          overflow-y: auto;
        `;
    }
    return `
        position: sticky;
        top: 74px;
        height: 100vh;
        overflow-y: auto;
      `;
}}
  }
`;
exports.ProfileContainer = (0, styled_1.default)('div') `
  @media screen {
    display: grid;
  }
  grid-template-areas: 'intro' 'content';
  grid-template-columns: 1fr;

  padding-bottom: ${constants_1.PROFILE_BOTTOM_HEIGHT};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  background: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_color_background')(props)};

  @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    grid-row-gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    grid-column-gap: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  }

  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    grid-template-areas: 'intro intro' 'profile-nav profile-nav' 'content action';
    grid-template-columns: 3fr minmax(325px, 1.25fr);
    padding-bottom: 0;
  }
`;
exports.Content = (0, styled_1.default)('div') `
  grid-area: content;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;
exports.ProfileNavigationContainer = (0, styled_1.default)('div') `
  @media screen and (max-width: ${constants_1.BREAKPOINTS.large - 1}px) {
    display: none;
  }
  grid-area: profile-nav;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 900;
  background: ${(0, ui_theme_1.fromTheme)('provider_profile_color_background')};
  // override styles in the DropdownTabs component
  & nav {
    padding: 0;
    border: none;
    border-bottom: ${(0, ui_theme_1.fromTheme)('provider_profile_border_style')}
      ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')}
      ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')};
    background: ${(0, ui_theme_1.fromTheme)('provider_profile_color_background')};
    border-radius: 0;
    align-items: flex-end;
  }
  & nav > a {
    background: ${(0, ui_theme_1.fromTheme)('provider_profile_color_background')};
  }
`;
exports.ProfileCenterMeta = (0, styled_1.default)('div') `
  flex: 1 1 auto;
`;
exports.ProfileCenterTopContainer = (0, styled_1.default)('div') `
  grid-area: intro;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  display: flex;
  flex-direction: column;
  position: relative;

  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  text-align: center;
  border-radius: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_border_radius')(props)};
  border: ${(props) => `${(0, ui_theme_1.fromTheme)('provider_profile_border_style')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')(props)}`};
  box-shadow: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
  -webkit-box-shadow: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
  -moz-box-shadow: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};

  div,
  ul {
    justify-content: center;
  }

  @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    flex-direction: row;
    margin: 0 0 -${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
    padding: 0;
    text-align: initial;
    border: none;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;

    div,
    ul {
      justify-content: flex-start;
    }
  }
`;
exports.MobileAvailabilityContainer = (0, styled_1.default)(card_container_styles_1.Card) `
  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    display: none;
  }
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_xlarge')} 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  border: none;
  background: none;
`;
exports.ProviderBadgesWrapper = (0, styled_1.default)('div') `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;

  // target the badges and override their spacing styles
  div.MuiChip-root {
    margin: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }

  @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0 0 0;

    // target the badges and override their spacing styles
    div.MuiChip-root {
      margin: 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
    }
  }
`;
exports.ReviewsSummaryWrapper = (0, styled_1.default)('div') `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  text-align: initial;
  @media screen and (max-width: ${constants_1.BREAKPOINTS.small}px) {
    margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  }
`;
exports.ProfileSectionWrapper = (0, styled_1.default)('div') `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};

  // negative offset to account for padding scrolling section headings into view
  padding-top: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
  margin-top: -${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
`;
exports.ShowContactInMobileWrapper = (0, styled_1.default)(exports.ProfileSectionWrapper) `
  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    display: none;
  }
`;
exports.ShowContactInMobile = (0, styled_1.default)(card_container_styles_1.Card) `
  > div {
    border: none;
    padding: 0;
    margin: 0;
  }
`;
//# sourceMappingURL=provider-profile.styles.js.map